import { makeStyles } from "@material-ui/core/styles";

export const answerStyles = makeStyles((theme) => ({
  answer: {
    borderRadius: "8px",
    fontWeight: "bold",
    textAlign: "center",
    textTransform: "none",
    height: 72,
    fontFamily: "Lato",
    backgroundColor: "#FFF",
    "&:hover": {
      boxShadow: "inset 0px -4px 0px #A7BBD4",
      backgroundColor: "#ECF3F8",
      border: "1px solid #A7BBD4",
    },
    [theme.breakpoints.down("sm")]: {
      margin: "-2px",
    },
  },
  selected: {
    backgroundColor: "#ECF3F8",

    "&:hover": {
      boxShadow: "inset 0px -4px 0px #A7BBD4",
      backgroundColor: "#ECF3F8",
    },
  },
  unselected: {
    border: "1px solid black",
    color: "black",
  },
}));
